import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, ReplaySubject } from 'rxjs';
import { User } from '../models/user';
import { Profile } from '../models/profile';
import { MicroDroits } from '../models/micro.droits';

@Injectable({
  providedIn: 'root'
})
export class SessionService {


  public _userBs: BehaviorSubject<User> = new BehaviorSubject(new User());
  public _dateBs: BehaviorSubject<string> = new BehaviorSubject('');
  private user: User = null;
  public preferenceList: Observable<any[]> = null;

  private readonly _activeProfile: ReplaySubject<Profile> = new ReplaySubject(1);

  /**
   * The active profile in current use
   */
  public get activeProfile(): Observable<Profile> {
    return this._activeProfile;
  }

  constructor() { }

  public getUser(): User {
    if (this.user === null) {
      this.user = Object.assign(new User(), JSON.parse(sessionStorage.getItem('user')) as User);
    }
    return this.user;
  }

  public setUser(user: User): void {
    this.user = user;
    sessionStorage.setItem('user', JSON.stringify(user));
  }

  /**
   * Set a user in session.
   * 
   * If you have a <emph>profile</emph> available, use
   * @link SessionConnectorService#connect instead.
   * 
   * @param user The user to connect
   */
  public connect(profile: Profile) {
      this._dateBs.next(new Date().toISOString());
      this._userBs.next(profile.user);
      this.setUser(profile.user);
      this._activeProfile.next(profile);
  }
  
  public clear() {
    const user = new User();
    const profile = new Profile();
    profile.user = user;
    profile.microDroits = new MicroDroits();
    profile.microDroits.microDroits = [];


    this._dateBs.next('');
    this._userBs.next(user);
    this.setUser(user);
    this._activeProfile.next(profile);
  }
}
